import { render, staticRenderFns } from "./TableButtons.vue?vue&type=template&id=d59a7d10&scoped=true&"
import script from "./TableButtons.vue?vue&type=script&lang=js&"
export * from "./TableButtons.vue?vue&type=script&lang=js&"
import style0 from "./TableButtons.vue?vue&type=style&index=0&id=d59a7d10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d59a7d10",
  null
  
)

export default component.exports